import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Equipment } from "../model/Equipment.model";
import { URL_API } from "./url.api";
import { Client } from "../model/Client.model";
import { SectorDTO } from "../model/SectorDTO.model";
import { Sector } from "../model/Sector.model";

@Injectable({
    providedIn: 'root'
})
export class SectorService {

    constructor(
        private http: HttpClient
    ){}

    save(sector: Sector): Observable<any> {
        return this.http.post<any>(`${URL_API}/sectors`, sector);
    }

    update(sector: SectorDTO): Observable<any> {
        return this.http.put<any>(`${URL_API}/sectors/${sector.id}`, sector);
    }

    delete(sector: SectorDTO): Observable<any> {
        return this.http.delete<any>(`${URL_API}/sectors/${sector.id}`);
    }

    findEquipmentBySector(sector: SectorDTO): Observable<Array<Equipment>> {
        return this.http.get<Array<Equipment>>(`${URL_API}/sectors/${sector.id}/equipment`);
    }

    findByClient(client: Client): Observable<Array<SectorDTO>> {
        return this.http.get<Array<SectorDTO>>(`${URL_API}/sectors/${client.id}/client`);
    }
}